import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import useTableFijo from "../../useTableFijo";
import moment from "moment";
import { InfoButton } from "../../../ui/buttons/Button";
const headCells = [
  {
    id: "numfactura",
    label: "Nº FACTURA",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "fechaemision",
    label: "FECHA EMISION",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DECRIPCION",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "MONTO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "status",
    label: "ESTATUS",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

const TablaFacturasPagas = (props) => {
  let op = require("../../../../src/modulos/datos");

  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320,
  );

  useEffect(() => {
    setRecords(props.tabfacC);
  }, [props.tabfacC]);

  console.log(props.idcomercio);

  const imprimirDeudaGeneral = () => {
    var reporte = "RelacionFactPagadas";
    var idcomercio = props.idcomercio;
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        idcomercio,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  return (
    <div className="col-12 m-0 mt-2 p-0">
      <InfoButton
        className="mr-auto"
        icon="fa-print m-0"
        onClick={imprimirDeudaGeneral}
      />

      <TblContainer
        container={{
          height: 250,
          width: "100%",
          overflow: "auto",
          padding: "2px",
        }}
      >
        <TblHead />

        <tbody>
          {records &&
            records.map((item, index) => (
              <tr key={item.idfactura} style={{ padding: "0" }}>
                <td
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "100px",
                  }}
                >
                  {item.numfactura !== "" ? item.numfactura.trim() : ""}
                </td>
                <td
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "100px",
                  }}
                >
                  {moment.utc(item.fechaemision).format("DD/MM/YYYY")}
                </td>
                <td
                  style={{ fontSize: "10px", textAlign: "left", width: "auto" }}
                >
                  {item.descripcion}
                </td>
                <td
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "auto",
                  }}
                >
                  {formatMoneda(
                    (item.totfacura || 0).toString().replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </td>
                <td
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "auto",
                  }}
                >
                  {item.status}
                </td>
              </tr>
            ))}
        </tbody>
      </TblContainer>
    </div>
  );
};

export default TablaFacturasPagas;
